import React, { Component } from 'react'
import Image from 'components/common/ImageLoader'
import CancelIcon from 'assets/cancel.svg'

const PageNotFound = (props) => {
    return (
        <div className="page-not-found-container mt-40">
            <div className="flex flex-wrap justify-center items-center">
                <div>
                    <div>
                        <Image width={150} height={150} src={CancelIcon} />
                    </div>
                </div>
                <div className="ml-20">
                    <div className="text-6xl">404 Missing.</div>
                    <div className="text-3xl">
                        Oops! The page you were looking doesn't exist.{' '}
                    </div>
                    <div className="mt-6 pt-6">
                        <button
                            className=" px-4 py-2  bg-white text-primary-500 
              hover:bg-primary-500 hover:text-white 
              border border-primary-500
              transition duration-200 ease-in-out"
                            onClick={() => props.history.replace('/')}
                        >
                            Home
                        </button>
                        <button
                            className=" ml-4 px-4 py-2 bg-white text-primary-500 
              hover:bg-primary-500 hover:text-white 
              border border-primary-500
              transition duration-200 ease-in-out
              "
                            onClick={() => props.history.goBack()}
                        >
                            Go Back
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageNotFound
